'use client';
import {useEffect, useRef} from 'react';
import {useSelectedScreenIds} from '@features/activeScreenIdContext/useSelectedScreenIds';
import {trpc} from '@features/utils/trpc';
import {useSession} from '@features/auth/authClient';

/**
 * Isolated component that syncs selected screen IDs to workspace state.
 * Extracted from Canvas/useCanvas so that selection changes
 * don't rerender the entire canvas and all its nodes.
 */
export function WorkspaceSync() {
  const {isAuthenticated} = useSession();
  const selectedScreenIds = useSelectedScreenIds();
  const updateWorkspace = trpc.workspace.updateWorkspaceState.useMutation();
  const debounceRef = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!isAuthenticated) return;
    if (selectedScreenIds.length === 0) return;
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      updateWorkspace.mutate({selectedScreenIds});
    }, 300);
    return () => clearTimeout(debounceRef.current);
    // debounced fire on selection change, updateWorkspace.mutate is stable across renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedScreenIds, isAuthenticated]);

  return null;
}
